import { lazy } from "react"

const IncubatingPage$$__react__lazy__component = lazy(() => 
    import("./IncubatingPage__original__module.mjs")
        .then(module => module.get_$$IncubatingPage$$IncubatingPage$$react__component$$3ld1wy2m1s077())
        .then(component => ({ default: component }))
)

export const get_$$IncubatingPage$$IncubatingPage$$react__component$$3ld1wy2m1s077 = () => IncubatingPage$$__react__lazy__component